export default "__VITE_PUBLIC_ASSET__bc612ec7__"